type NameProps = {
  name: string;
};

let colorMap = new Map();

function RandomColor(props: NameProps) {
  colorMap.set("THỂ THAO", "hsl(181, 100%, 60%)");
  colorMap.set("GIÁO DỤC", "hsl(360, 100%, 90%)");
  colorMap.set("KHOA HỌC - CÔNG NGHỆ", "hsl(232, 72%, 66%)");
  colorMap.set("PHÁP LUẬT", "hsl(24, 94%, 74%)");
  colorMap.set("KINH TẾ", "hsl(126, 94%, 74%)");
  colorMap.set("SỨC KHỎE - ĐỜI SỐNG", "hsl(320, 100%, 80%)");
  colorMap.set("GIẢI TRÍ", "hsl(1, 94%, 74%)");
  colorMap.set("TIN TỨC", "hsl(47, 72%, 66%)");
  colorMap.set("CHÍNH TRỊ - XÃ HỘI", "hsl(70, 94%, 74%)");
  colorMap.set("THẾ GIỚI", "hsl(221, 94%, 74%)");
  colorMap.set("OWNED", "hsl(201, 100%, 93%)");
  colorMap.set("OWNER", "hsl(201, 100%, 93%)");
  colorMap.set("OPPONENT", "hsl(6, 100%, 93%)");
  colorMap.set("PARTNER", "hsl(131, 100%, 93%)");
  colorMap.set("UNKNOWN", "hsl(1, 0%, 90%)");
  if (colorMap.get(props.name.toUpperCase()) != null) {
    return colorMap.get(props.name.toUpperCase());
  }
  const randomInt = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  var h = randomInt(0, 360);
  var s = randomInt(15, 90);
  var l = randomInt(75, 90);
  colorMap.set(props.name.toUpperCase(), `hsl(${h},${s}%,${l}%)`);
}

export default RandomColor;
